import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { alcoholVoluntaryCounselingAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { isPVQForm } from 'helpers/form';
import { SubstanceAlcoholVoluntaryCounselingModel } from './types';
import substanceAlcoholVoluntaryCounselingItemValidator from './validators/item';

const substanceAlcoholVoluntaryCounselingValidator: ValidateJSModel<SubstanceAlcoholVoluntaryCounselingModel> = {
  SoughtTreatment: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (attributes?.SoughtTreatment && attributes?.SoughtTreatment.value === 'Yes') {
      if (isPVQForm(options?.formType)) {
        return {
          presence: true,
          accordion: { validator: substanceAlcoholVoluntaryCounselingItemValidator },
        };
      }

      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, alcoholVoluntaryCounselingAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: substanceAlcoholVoluntaryCounselingItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceAlcoholVoluntaryCounselingValidator;
